<form
    [name]="form.name"
    [formGroup]="form.form"
    (ngSubmit)="onSubmit()"
>
    <div class="text-right">
        <a
            class="btn btn-primary"
            target="_blank"
            tabindex="-1"
            [attr.aria-label]="i18n._7205_PRINT_PREVIEW | translate"
            [routerLink]="['print-preview']"
            [queryParams]="{ tpl: templateId, data: payload.dataId }"
            [ngbTooltip]="i18n._7205_PRINT_PREVIEW | translate"
            placement="left"
            *ngIf="payload.flowState === FlowState.COMPLETE"
        >
            <cmps-icon svgIcon="printer"></cmps-icon>
        </a>
    </div>
    <div class="form-group">
        <div
            class="mb-3"
            [innerHTML]="'form_memberInstruction' | translate"
            *ngIf="
                isMember &&
                memberCanSubmit &&
                memberCanEdit &&
                isMemberSelf &&
                isWithinCurrentDateRange
            "
        ></div>
        <label
            [id]="form.fields.LOOKING_BACK.labelId"
            [htmlFor]="form.fields.LOOKING_BACK.id"
            >{{ form.fields.LOOKING_BACK.label | translate }}</label
        >
        <div
            [innerHTML]="'form_lookingBackDescription' | translate"
            *ngIf="
                isMember &&
                memberCanSubmit &&
                memberCanEdit &&
                isMemberSelf &&
                isWithinCurrentDateRange
            "
        ></div>
        <textarea
            class="form-control"
            [id]="form.fields.LOOKING_BACK.id"
            [placeholder]="form.fields.LOOKING_BACK.placeholder | translate"
            rows="10"
            [hidden]="
                isManager ||
                !(
                    isMember &&
                    memberCanSubmit &&
                    memberCanEdit &&
                    isMemberSelf
                ) ||
                !isWithinCurrentDateRange
            "
            [formControlName]="form.fields.LOOKING_BACK.name"
        ></textarea>
        <ng-container
            *ngIf="
                isMember &&
                memberCanSubmit &&
                memberCanEdit &&
                isMemberSelf &&
                isWithinCurrentDateRange
            "
        >
            <div class="text-right mt-1">
                {{
                    MAX_LENGTH -
                        form.form.controls[form.fields.LOOKING_BACK.name].value
                            ?.length
                }}
                / {{ MAX_LENGTH }}
            </div>
            <div
                class="alert alert-warning mt-1 mb-0"
                role="alert"
                *ngIf="form.errors.LOOKING_BACK"
            >
                {{ form.errors.LOOKING_BACK }}
            </div>
        </ng-container>
        <div
            [innerText]="
                form.form.controls[form.fields.LOOKING_BACK.name].value
            "
            *ngIf="
                isManager ||
                !memberCanEdit ||
                !isMemberSelf ||
                !isWithinCurrentDateRange
            "
        ></div>
    </div>
    <div class="form-group">
        <label
            [id]="form.fields.LOOKING_FORWARD.labelId"
            [htmlFor]="form.fields.LOOKING_FORWARD.id"
            >{{ form.fields.LOOKING_FORWARD.label | translate }}</label
        >
        <div
            [innerHTML]="'form_lookingForwardDescription' | translate"
            *ngIf="
                isMember &&
                memberCanSubmit &&
                memberCanEdit &&
                isMemberSelf &&
                isWithinCurrentDateRange
            "
        ></div>
        <textarea
            class="form-control"
            [id]="form.fields.LOOKING_FORWARD.id"
            [placeholder]="form.fields.LOOKING_FORWARD.placeholder | translate"
            rows="10"
            [hidden]="
                isManager ||
                !(
                    isMember &&
                    memberCanSubmit &&
                    memberCanEdit &&
                    isMemberSelf
                ) ||
                !isWithinCurrentDateRange
            "
            [formControlName]="form.fields.LOOKING_FORWARD.name"
        ></textarea>
        <ng-container
            *ngIf="
                isMember &&
                memberCanSubmit &&
                memberCanEdit &&
                isMemberSelf &&
                isWithinCurrentDateRange
            "
        >
            <div class="text-right mt-1">
                {{
                    MAX_LENGTH -
                        form.form.controls[form.fields.LOOKING_FORWARD.name]
                            .value?.length
                }}
                / {{ MAX_LENGTH }}
            </div>
            <div
                class="alert alert-warning mt-1 mb-0"
                role="alert"
                *ngIf="form.errors.LOOKING_FORWARD"
            >
                {{ form.errors.LOOKING_FORWARD }}
            </div>
        </ng-container>
        <ng-container
            *ngIf="
                isManager ||
                !memberCanEdit ||
                !isMemberSelf ||
                !isWithinCurrentDateRange
            "
        >
            <div
                [innerText]="
                    form.form.controls[form.fields.LOOKING_FORWARD.name].value
                "
            ></div>
            <div
                class="mt-2 mb-2"
                *ngIf="payload.flowState === FlowState.MEMBER_REVIEW_SUBMITTED"
            >
                <span>{{
                    payload.lastModifiedMember == null
                        ? (i18n._842_N_A | translate)
                        : (payload.lastModifiedMember
                          | cmpsDate: 'y-MM-dd h:mm a')
                }}</span>
            </div>
        </ng-container>
    </div>

    <ng-container
        [ngSwitch]="payload.flowState"
        *ngIf="
            isMember &&
            memberCanSubmit &&
            isMemberSelf &&
            isWithinCurrentDateRange
        "
    >
        <div *ngSwitchCase="FlowState.MEMBER_DRAFT">
            <button
                type="button"
                class="btn btn-primary"
                [disabled]="state?.pending"
                (click)="onSaveDraftClick()"
            >
                <span>
                    <cmps-icon
                        class="cmps-cdk-mr-0dot25"
                        svgIcon="file"
                    ></cmps-icon>
                    {{ i18n._7200_SAVE_DRAFT | translate }}
                </span>
            </button>
            <button
                type="submit"
                class="btn btn-primary"
                [disabled]="state?.pending || !form.form.valid"
            >
                {{ i18n._7201_SUBMIT | translate }}
            </button>
        </div>
        <div
            *ngSwitchCase="FlowState.MEMBER_REVIEW"
            class="mb-4"
        >
            <button
                type="button"
                class="btn btn-primary"
                [disabled]="state?.pending"
                (click)="onFinalEditClick()"
                *ngIf="state?.readonly"
            >
                <span
                    >{{ i18n._7202_FINAL_EDIT | translate }}
                    <cmps-icon
                        class="cmps-cdk-ml-0dot25"
                        svgIcon="pencil-outline"
                    ></cmps-icon>
                </span>
            </button>
            <button
                type="submit"
                class="btn btn-primary"
                [disabled]="state?.pending"
                *ngIf="!state?.readonly"
            >
                {{ i18n._7201_SUBMIT | translate }}
            </button>
        </div>
    </ng-container>

    <div
        class="mt-4"
        [innerHTML]="'form_reminder' | translate"
        *ngIf="
            payload.flowState !== FlowState.COMPLETE && isWithinCurrentDateRange
        "
    ></div>

    <ng-container
        *ngIf="
            isManager ||
            (payload.flowState !== FlowState.MEMBER_DRAFT &&
                payload.flowState !== FlowState.MEMBER_SUBMITTED)
        "
    >
        <div class="form-group mt-4">
            <div
                class="mb-3"
                [innerHTML]="'form_managerInstruction' | translate"
                *ngIf="
                    isManager &&
                    managerCanSubmit &&
                    managerCanEdit &&
                    isWithinCurrentDateRange
                "
            ></div>
            <label
                [id]="form.fields.CONVERSATION_SUMMARY.labelId"
                [htmlFor]="form.fields.CONVERSATION_SUMMARY.id"
                >{{ form.fields.CONVERSATION_SUMMARY.label | translate }}</label
            >
            <textarea
                class="form-control"
                [id]="form.fields.CONVERSATION_SUMMARY.id"
                [placeholder]="
                    form.fields.CONVERSATION_SUMMARY.placeholder | translate
                "
                rows="10"
                [hidden]="
                    isMember ||
                    !(isManager && managerCanSubmit && managerCanEdit) ||
                    !isWithinCurrentDateRange
                "
                [formControlName]="form.fields.CONVERSATION_SUMMARY.name"
            ></textarea>
            <ng-container
                *ngIf="
                    isManager &&
                    managerCanSubmit &&
                    managerCanEdit &&
                    isWithinCurrentDateRange
                "
            >
                <div class="text-right mt-1">
                    {{
                        MAX_LENGTH -
                            form.form.controls[
                                form.fields.CONVERSATION_SUMMARY.name
                            ].value?.length
                    }}
                    / {{ MAX_LENGTH }}
                </div>
                <div
                    class="alert alert-warning mt-1 mb-0"
                    role="alert"
                    *ngIf="form.errors.CONVERSATION_SUMMARY"
                >
                    {{ form.errors.CONVERSATION_SUMMARY }}
                </div>
            </ng-container>
            <ng-container
                *ngIf="isMember || !managerCanEdit || !isWithinCurrentDateRange"
            >
                <div
                    [innerText]="
                        form.form.controls[
                            form.fields.CONVERSATION_SUMMARY.name
                        ].value
                    "
                ></div>
                <div
                    class="mt-2 mb-2"
                    *ngIf="
                        payload.flowState === FlowState.MEMBER_REVIEW ||
                        payload.flowState === FlowState.MEMBER_REVIEW_SUBMITTED
                    "
                >
                    <span
                        >{{
                            payload.lastModifiedManager == null
                                ? (i18n._842_N_A | translate)
                                : (payload.lastModifiedManager
                                  | cmpsDate: 'y-MM-dd h:mm a')
                        }}
                        | {{ payload.managerInfo.firstName }}
                        {{ payload.managerInfo.lastName }} |
                        {{ payload.managerInfo.roleName }}</span
                    >
                </div>
            </ng-container>
        </div>

        <ng-container
            *ngIf="isManager && managerCanSubmit && isWithinCurrentDateRange"
        >
            <div
                class="text-right"
                *ngIf="
                    payload.flowState === FlowState.MEMBER_SUBMITTED ||
                    payload.flowState === FlowState.MANAGER_DRAFT
                "
            >
                <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="state?.pending"
                    (click)="onSaveDraftClick()"
                >
                    <span>
                        <cmps-icon
                            class="cmps-cdk-mr-0dot25"
                            svgIcon="file"
                        ></cmps-icon>
                        {{ i18n._7200_SAVE_DRAFT | translate }}
                    </span>
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="state?.pending"
                    (click)="onReturnToMemberClick()"
                >
                    {{ i18n._7203_SEND_BACK | translate }}
                </button>
                <button
                    type="submit"
                    class="btn btn-primary"
                    [disabled]="state?.pending"
                >
                    {{ i18n._7204_COMPLETE | translate }}
                </button>
            </div>
            <div
                class="text-right"
                *ngIf="payload.flowState === FlowState.MEMBER_REVIEW_SUBMITTED"
            >
                <button
                    type="submit"
                    class="btn btn-primary"
                    [disabled]="state?.pending"
                >
                    {{ i18n._7204_COMPLETE | translate }}
                </button>
            </div>
        </ng-container>
    </ng-container>
</form>
